import { NgModule } from "@angular/core";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyMaterialModule } from "@ngx-formly/material";
import { FormlyMatDatepickerModule } from "@ngx-formly/material/datepicker";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { CommonModule } from "@angular/common";
import { GwallRhestrComponent } from "./gwall-rhestr/gwall-rhestr.component";
import { AtebDyddiolComponent } from "./ateb-dyddiol/ateb-dyddiol.component";
import { UiModule } from "../ui/ui.module";
import { LabelCwestiwnFormlyComponent } from "./label-cwestiwn-formly/label-cwestiwn-formly.component";
import { MaesDiogelwchComponent } from "./diogelwch/maes-diogelwch/maes-diogelwch.component";
import { TranslateModule } from "@ngx-translate/core";
import { IsMaesDiogelwchComponent } from "./diogelwch/is-maes-diogelwch/is-maes-diogelwch.component";
import { FfurflenDiogelwchComponent } from "./diogelwch/ffurflen-diogelwch/ffurflen-diogelwch.component";
import { MaesDiogelwchTeiarsComponent } from "./diogelwch/maes-diogelwch-teiars/maes-diogelwch-teiars.component";
import { MaesDiogelwchTeiarUnigolComponent } from "./diogelwch/maes-diogelwch-teiar-unigol/maes-diogelwch-teiar-unigol.component";
import { BlwchGwagComponent } from "./blwch-gwag/blwch-gwag.component";
import { MaesDiogelwchTeiarFlexComponent } from "./diogelwch/maes-diogelwch-teiar-flex/maes-diogelwch-teiar-flex.component";
import { MaesDiogelwchBrecComponent } from "./diogelwch/maes-diogelwch-brec/maes-diogelwch-brec.component";
import { CyfrinairComponent } from "./cyfrinair/cyfrinair.component";
import { CwestiwnService } from "src/app/craidd/gwasanaethau/system/cwestiwn.service";
import { DamwainCerbydArallComponent } from "./damwain/damwain-cerbyd-arall/damwain-cerbyd-arall.component";
import { EglurhadComponent } from "./damwain/eglurhad/eglurhad.component";
import { CwestiwnComponent } from "./cwestiwn/cwestiwn.component";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { DropdownFormlyComponent } from "./dropdown-formly/dropdown-formly.component";
import { RadioButtonCodMarcioFormlyComponent } from "./radio-button-cod-marcio-formly/radio-button-cod-marcio-formly.component";
import { RadioButtonFormlyComponent } from "./radio-button-formly/radio-button-formly.component";
import { RepeatFormlyComponent } from "./repeat-formly/repeat-formly.component";
import { FfurflenGwirioComponent } from "./dyddiol/ffurflen-gwirio/ffurflen-gwirio.component";
import { MaesGwirioComponent } from "./dyddiol/maes-gwirio/maes-gwirio.component";
import { IsMaesGwirioComponent } from "./dyddiol/is-maes-gwirio/is-maes-gwirio.component";
import { GwallHintComponent } from "./gwall-hint/gwall-hint.component";
import { CwestiwnTabsComponent } from "./cwestiwn-tabs/cwestiwn-tabs.component";
import { BotwmFormlyComponent } from "./botwm-formly/botwm-formly.component";
import { DateTimeMateroComponent } from "./date-time-matero/date-time-matero.component";
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { FormlyFormComponent } from "./formly-form/formly-form.component";
import { FormlyFormFlexComponent } from "./formly-form-flex/formly-form-flex.component";

@NgModule({
    imports: [
        CommonModule,
        UiModule,
        TranslateModule,
        LocalizeRouterModule,
        FlexLayoutModule,
        FormlyModule.forRoot({
            extras: {
                checkExpressionOn: "modelChange",
            },
            validationMessages: [
                { name: "gwall", message: (error: string) => error },
            ],
            types: [
                {
                    name: "flex-layout",
                    component: FormlyFormFlexComponent,
                },
                {
                    name: "form-layout",
                    component: FormlyFormComponent,
                },
                {
                    name: "datetimepicker-matero",
                    component: DateTimeMateroComponent,
                },
                {
                    name: "repeat",
                    component: RepeatFormlyComponent,
                },
                {
                    name: "ateb-dyddiol",
                    component: AtebDyddiolComponent,
                },
                {
                    name: "dropdown",
                    component: DropdownFormlyComponent,
                },
                {
                    name: "radio-button",
                    component: RadioButtonFormlyComponent,
                },
                {
                    name: "radio-button-cod-marcio",
                    component: RadioButtonCodMarcioFormlyComponent,
                },
                {
                    name: "blwch-gwag",
                    component: BlwchGwagComponent,
                },
                // Diogelwch
                {
                    name: "ffurflen-diogelwch",
                    component: FfurflenDiogelwchComponent,
                },
                {
                    name: "maes-diogelwch",
                    component: MaesDiogelwchComponent,
                },
                {
                    name: "maes-diogelwch-teiars",
                    component: MaesDiogelwchTeiarsComponent,
                },
                {
                    name: "maes-diogelwch-teiar-flex",
                    component: MaesDiogelwchTeiarFlexComponent,
                },
                {
                    name: "maes-diogelwch-teiar-unigol",
                    component: MaesDiogelwchTeiarUnigolComponent,
                },
                {
                    name: "maes-diogelwch-brec",
                    component: MaesDiogelwchBrecComponent,
                },
                {
                    name: "is-maes-diogelwch",
                    component: IsMaesDiogelwchComponent,
                },
                {
                    name: "cyfrinair",
                    component: CyfrinairComponent,
                },
                {
                    name: "ffurflen-gwirio",
                    component: FfurflenGwirioComponent,
                },
                {
                    name: "maes-gwirio",
                    component: MaesGwirioComponent,
                },
                {
                    name: "is-maes-gwirio",
                    component: IsMaesGwirioComponent,
                },
                {
                    name: "botwm",
                    component: BotwmFormlyComponent,
                },
                // Damwain
                {
                    name: "damwain-cerbyd-arall",
                    component: DamwainCerbydArallComponent,
                },
                {
                    name: "eglurhad",
                    component: EglurhadComponent,
                },
            ],
        }),
        FormlyMatDatepickerModule,
        FormlyMaterialModule,
        GwallRhestrComponent,
        AtebDyddiolComponent,
        LabelCwestiwnFormlyComponent,
        RepeatFormlyComponent,
        MaesDiogelwchComponent,
        IsMaesDiogelwchComponent,
        FfurflenDiogelwchComponent,
        MaesDiogelwchTeiarsComponent,
        MaesDiogelwchTeiarUnigolComponent,
        BlwchGwagComponent,
        MaesDiogelwchTeiarFlexComponent,
        MaesDiogelwchBrecComponent,
        CyfrinairComponent,
        DamwainCerbydArallComponent,
        EglurhadComponent,
        CwestiwnComponent,
        DropdownFormlyComponent,
        RadioButtonCodMarcioFormlyComponent,
        RadioButtonFormlyComponent,
        FfurflenGwirioComponent,
        MaesGwirioComponent,
        IsMaesGwirioComponent,
        GwallHintComponent,
        CwestiwnTabsComponent,
        BotwmFormlyComponent,
        DateTimeMateroComponent,
        FormlyFormFlexComponent,
        FormlyFormComponent,
    ],
    exports: [FormlyModule, FormlyMaterialModule, GwallRhestrComponent, CwestiwnComponent, CwestiwnTabsComponent],
    providers: [CwestiwnService],
})
export class CwestiwnModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas);
  }
}
